import React from 'react'
import styled from 'styled-components'
import { Button } from '../../components/Button'
import { STYLES } from '../../static/style'
import { DoubleDownIcon } from '../../components/Icon/DoubleDownIcon'
import { Text } from '../../components/Text'

const StyledLoadMoreButton = styled(Button)`
  display: flex;
  background: ${STYLES.COLOR_WHITE};
  justify-content: center;
  align-items: center;
  border-radius: ${STYLES.BORDER_RADIUS};
  border: 1px solid ${STYLES.BORDER_COLOR};
  padding: ${STYLES.GUTTER};
  color: ${STYLES.COLOR_OUTER_SPACE_GRAY};
  &:hover {
    background: ${STYLES.COLOR_WHITE};
    color: ${STYLES.PRIMARY_COLOR};
    border: 1px solid ${STYLES.PRIMARY_COLOR};
    text-decoration: none;
  }
  ${({ isHorizontal }: { isHorizontal: boolean }) =>
    isHorizontal &&
    `
    height: 100%;
    padding: 0 1rem;
    white-space: nowrap;
  `}
`

const LoadMoreText = styled(Text)`
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
`

const StyledDoubleDownIcon = styled(DoubleDownIcon)`
  margin-right: ${STYLES.GUTTER};
`

interface ILoadMoreButtonProps {
  onClick: () => void
  isHorizontal?: boolean
}

const LoadMoreButton: React.FC<ILoadMoreButtonProps> = ({
  onClick,
  isHorizontal = false,
}) => (
  <StyledLoadMoreButton
    label="Load more schools"
    onClick={onClick}
    isHorizontal={isHorizontal}
  >
    {!isHorizontal && <StyledDoubleDownIcon />}
    <LoadMoreText>Load more</LoadMoreText>
  </StyledLoadMoreButton>
)

export { LoadMoreButton }
